import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  constructor() { }

  scrollIntoView(route: ActivatedRoute) {
    route.params.subscribe(param => {
      if (param.id) {
        const section = document.querySelector('#' + param.id);
        if (section) {
          setTimeout(() => {
            section.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
          }, 500);  
        }
      }
    })
  }
}
